import { render } from "./InsuranceComponent.vue?vue&type=template&id=55d5a714"
import script from "./InsuranceComponent.vue?vue&type=script&lang=js"
export * from "./InsuranceComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__